import React from 'react'

import blogs_js from './articles.js';

import StartFooterCTA from './StartFooterCTA.js'
// todo: als de buildfile te groot wordt de images van een extern domein (images.pmnl of citrus-images.pmnl)


export default class extends React.Component {
  render() {
    document.title = "Blog · Citrus by Polymedia";
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/blog';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/blog';
    document.getElementsByTagName('title')[0].after(alt_en);

    let articles = blogs_js.map(function(article, i) {
      let permalink = "/blog-post/"+article.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/gi, '')+"-"+(blogs_js.length-i);
      return <article key={"a_"+i}>
        <img src={article.img} alt={"citrus.polymedia.nl | "+article.title} className="screenshot" />
        <a href={permalink} target="_blank" style={{color:"#444"}}><h1>{article.title}</h1></a>
        <small><time dateTime={article.date}>{article.date.substring(8,10)+"-"+article.date.substring(5,7)+"-"+article.date.substring(0,4)}</time> | <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">Peter van der Meer</a></small>
        <div dangerouslySetInnerHTML={{__html:article.text.substring(0,500)+(article.text.length > 500 ? '.. <a href="'+permalink+'" target="_blank">lees meer</a>' : "")}} />
      </article>;
    });
    return (
      <div>

        <div className="full greyish blog">
          <div className="wrap wrap-thin">
            <small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"12px", textAlign:"right"}}>{this.props.i18n_texts["gen_lastmodified"][this.props.app_language]} <time dateTime={blogs_js[0].date}>{blogs_js[0].date.substring(8,10)+"-"+blogs_js[0].date.substring(5,7)+"-"+blogs_js[0].date.substring(0,4)}</time>.</small>

            {articles}

          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Blog.js